import {
  EditableFormIdempotencyToken,
  type FeatureRegistry,
  FlowSubmissionIdempotencyToken,
} from '@betterment/graphql';

export const featureRegistry: FeatureRegistry = {
  planBenchmark: {
    GeneratePlanBenchmark: {
      idempotencyToken: FlowSubmissionIdempotencyToken,
    },
  },
  employees: {
    UpdateEmployeeContributionRates: {
      idempotencyToken: EditableFormIdempotencyToken,
    },
  },
  signablePackage: {
    CapturePackageSignature: {
      idempotencyToken: FlowSubmissionIdempotencyToken,
    },
    ForwardSignature: {
      idempotencyToken: EditableFormIdempotencyToken,
    },
    ReclaimPackageSignature: {
      idempotencyToken: EditableFormIdempotencyToken,
    },
  },
  reports: {
    CreateBenefitReport: {
      idempotencyToken: FlowSubmissionIdempotencyToken,
    },
  },
};
